export const newBrandingOldEvent = (eid) => {
    const eids = [30502,41256,41257, 27950];
    return eids.includes(parseInt(eid));
};